import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import CoursesList from "./Components/CourseList";
import CourseDetails from "./Components/CourseDetails";
import CourseRequests from "./Components/CourseRequests";
import FolderComponent from "../../Components/FolderComponent";
import { Container } from "./styles";
import CourseMaterials from "./Components/CourseMaterials";
import Colors from "../../Constant/Colors";
import { useDispatch, useSelector } from "react-redux";
import NewCourse from "./Components/NewCourse";
import {
  getAllContentsRequest,
  getContentRequest,
  getSlugRequest,
} from "../../Redux/actions/home";
import QuizDetails from "./Components/QuizDetails";

const CoursesPage = ({ }) => {
  const dispatch = useDispatch();
  const location = useLocation();

  const { isInstructor } = useSelector((state) => state.auth);
  const { courseContent, courses, slugList } = useSelector(
    (state) => state.home
  );
  const [view, setView] = useState("list");
  const [selectedCourse, setSelectedCourse] = useState({});
  const [selectedMaterial, setSelectedMaterial] = useState({
    title: "Content",
    color: Colors.AssIcon,
    list: [],
  });
  const [heading, setHeading] = useState([
    {
      id: 0,
      title: "Content",
      isSelected: true,
      color: Colors.AssIcon,
    },
    {
      id: 1,
      title: "Quiz",
      color: Colors.blackColor,
      isSelected: false,
    },
  ]);


  const handleView = (nav, course, content) => {
    let courseObj = course;
    if (nav === "courseMaterial") {
      dispatch(getAllContentsRequest(course?.id));
      if (content) {
        let obj = heading.filter((f) => f.title.toLowerCase() === content)[0];
        dispatch(getAllContentsRequest(selectedCourse?.id));
        courseObj = courses.filter((f) => f.id === courseObj.id)[0];
      }
    }
    setSelectedCourse(courseObj);
    setView(nav);
  };
  useEffect(() => {
    if (courseContent?.success) {
      setSelectedMaterial((prev) => ({
        ...prev,
        title: "Photos",
        color: Colors.photoIcon,
        list: courseContent?.photos,
      }));
      setHeading([
        {
          id: 0,
          title: "Content",
          isSelected: true,
          color: Colors.AssIcon,
        },
        {
          id: 1,
          title: "Quiz",
          color: Colors.blackColor,
          isSelected: false,
        },
      ]);
    }
  }, [courseContent]);
  useEffect(() => {
    if (view === "list") {
      setHeading([
        {
          id: 0,
          title: "Content",
          isSelected: true,
          color: Colors.AssIcon,
        },
        {
          id: 1,
          title: "Quiz",
          color: Colors.blackColor,
          isSelected: false,
        },
      ]);
    }
  }, [view]);

  useEffect(() => {
    if (location?.state) {
      let { id, course, content } = location.state;
      handleView("courseMaterial", course, content);
      let arr = [...heading];
      arr.forEach((fe) => (fe.isSelected = fe.title.toLowerCase() === content));
      setHeading(arr);
      setTimeout(() => {

        dispatch(getContentRequest(id, content));
      }, 100);
    }
    if (!slugList.length) dispatch(getSlugRequest());
  }, []);

  return (
    <Container isInstructor={isInstructor}>
      {view === "details" ? (
        <CourseDetails
          handleView={handleView}
          course={selectedCourse}
          setHeading={setHeading}
          heading={heading}
        />
      ) : view === "courseRequests" ? (
        <CourseRequests handleView={handleView} course={selectedCourse} />
      ) : view === "new" ? (
        <NewCourse handleView={handleView} course={selectedCourse} />
      ) : view === "courseMaterial" ? (
        <CourseMaterials
          heading={heading}
          handleView={handleView}
          selectedMaterial={selectedMaterial}
          course={selectedCourse}
        />
      ) : view === "quizDetails" ? (
        <QuizDetails
          heading={heading}
          handleView={handleView}
          course={selectedCourse}
        />
      ) : (
        <CoursesList handleView={handleView} />
      )}
      {isInstructor && <FolderComponent handleView={handleView} />}
    </Container>
  );
};

export default CoursesPage;
